var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
import * as React from 'react';
import { Popup, PopupContent, } from '@vital-ui/react-popup';
import { MenuItem } from './styled';
import { Context } from './context';
export var Dropdown = function (_a) {
    var popup = _a.popup, children = _a.children, props = __rest(_a, ["popup", "children"]);
    return (React.createElement(Context.Consumer, null, function (_a) {
        var getMenuProps = _a.getMenuProps, isOpen = _a.isOpen;
        return (React.createElement(Popup, __assign({}, getMenuProps(), { popupVisible: isOpen, stretch: "width", popup: React.createElement(PopupContent, { maxHeight: "220px" }, popup) }, props), children));
    }));
};
export var DropdownItem = function (_a) {
    var item = _a.item, index = _a.index, children = _a.children, _b = _a.wrap, wrap = _b === void 0 ? true : _b, props = __rest(_a, ["item", "index", "children", "wrap"]);
    return (React.createElement(Context.Consumer, null, function (_a) {
        var getItemProps = _a.getItemProps, highlightedIndex = _a.highlightedIndex;
        return (React.createElement("li", __assign({}, getItemProps({
            index: index,
            item: item,
        }), props),
            React.createElement(MenuItem, { isWrap: wrap, hightlighted: highlightedIndex === index }, children)));
    }));
};
//# sourceMappingURL=Dropdown.js.map